const agents = {
  title: "Flows",
  subtitle: "Potencialize seus processos ágeis",
  description: "Gerencie os fluxos do workspace",
  moreIntegrations: "+{{count}} mais ferramentas",
  empty: {
    title: "Nenhum fluxo encontrado",
    description: "Crie um novo fluxo para começar"
  },
  new: {
    title: "Novo fluxo",
    description: "Crie um novo fluxo"
  },
  install: "Instalar",
  installing: "Instalando...",
  installSuccess: "Fluxo {{name}} instalado com sucesso",
  comingSoon: "Em breve",
  uninstall: "Desinstalar",
  uninstalling: "Desinstalando...",
  uninstallSuccess: "Fluxo {{name}} desinstalado com sucesso",
  confirmUninstall: "Desinstalar {{name}}",
  confirmUninstallDescription: "Esta ação é irreversível. Para confirmar, digite o nome do workspace atual abaixo.",
  errors: {
    missingInfo: "Informações necessárias faltando",
    invalidAgent: "Fluxo inválido ou não encontrado",
    installFailed: "Falha ao instalar o fluxo",
    uninstallFailed: "Falha ao desinstalar o fluxo",
    nameNotMatch: "O nome digitado não corresponde ao nome do fluxo",
    workspaceNameNotMatch: "O nome digitado não corresponde ao nome do workspace atual",
    workspaceDataError: "Erro ao obter informações do workspace"
  },
  untitled: "Sem título",
  settings: {
    title: "Configurações do fluxo",
    description: "Configure seu fluxo",
    type: "Tipo",
    version: "Versão",
    neverPublished: "Nunca publicado",
    saveButton: {
      label: "Salvar",
      saving: "Salvando...",
      success: "Alterações salvas com sucesso!",
      error: "Erro ao salvar as alterações"
    },
    publishButton: {
      label: "Publicar",
      publishing: "Publicando...",
      success: "Fluxo publicado com sucesso!",
      error: "Erro ao publicar o fluxo",
      confirmTitle: "Confirmar Publicação",
      confirmDescription: "Dê um nome e uma descrição para esta versão do fluxo.",
      confirm: "Sim, publicar",
      cancel: "Cancelar",
      versionNameLabel: "Nome da versão",
      versionNamePlaceholder: "Ex: Versão Beta 1.0",
      versionNameError: "Este nome já está em uso. Por favor, escolha outro nome.",
      versionNameRequired: "O nome da versão é obrigatório",
      versionDescriptionLabel: "Descrição da versão",
      versionDescriptionPlaceholder: "Ex: Melhorias na integração com API externa",
      versionDescriptionRequired: "A descrição da versão é obrigatória",
      workflowSchemaRequired: "O esquema do workflow é obrigatório",
      versionAutoGenerated: "O número da versão é gerado automaticamente e não pode ser editado"
    },
    unsavedChangesDialog: {
      title: "Alterações não publicadas",
      description: "Você possui alterações que ainda não foram publicadas. Se sair agora, essas mudanças serão perdidas.",
      continueEditing: "Continuar Editando",
      discardAndExit: "Descartar e Sair"
    },
    notFound: "Fluxo não encontrado",
    disconnected: "Desconectado",
    updateSuccess: "Fluxo atualizado",
    updateSuccessDescription: "O fluxo foi atualizado com sucesso",
    updateErrorDescription: "Ocorreu um erro ao atualizar o fluxo",
    publishSuccess: "Fluxo publicado",
    publishSuccessDescription: "O fluxo foi publicado com sucesso",
    publishErrorDescription: "Ocorreu um erro ao publicar o fluxo",
    unsavedChanges: "Há alterações não publicadas",
    tabs: {
      integrations: "Ferramentas",
      prompts: "Prompts",
      parameters: "Parâmetros",
      workflow: "Workflow",
      versions: 'Versões',
      executions: "Execuções",
      dangerZone: "Zona de Perigo"
    },
    dangerZoneDescription: "Ações perigosas como desinstalação podem causar perda de dados. Prossiga com cautela.",
    uninstallButton: {
      label: "Desinstalar este fluxo",
      confirmTitle: "Confirmar desinstalação",
      confirmDescription: "Esta ação é irreversível e removerá o fluxo do workspace atual. Para confirmar, digite o nome exato do workspace.",
      confirmAgentNameLabel: "Nome do workspace",
      confirmAgentNamePlaceholder: "Digite o nome do workspace para confirmar",
      typeName: "Digite o nome",
      uninstalling: "Desinstalando...",
      uninstallingTitle: "Desinstalando fluxo",
      uninstallingProgress: "Progresso: {{progress}}%",
      uninstallingDescription: "Removendo {{name}} do workspace atual",
      uninstallingStep: "Desinstalando",
      uninstallingMessage: "Isso pode levar alguns instantes, por favor aguarde...",
      uninstalledMessage: "Desinstalação concluída! Redirecionando...",
      confirm: "Desinstalar",
      cancel: "Cancelar"
    },
    general: {
      version: "Versão",
      lastPublished: "Última publicação",
      noDescription: "Sem descrição"
    },
    prompts: {
      title: "Prompts do Sistema",
      add: "Adicionar seção",
      delete: "Excluir",
      preview: "Visualizar",
      edit: "Editar",
      untitled: "Sem título",
      noSections: "Nenhuma seção de prompt configurada",
      cannotDeleteLast: "Não é possível excluir a última seção de prompt",
      locked: "Este prompt está bloqueado e não pode ser editado",
      cancel: "Cancelar",
      systemPrompt: "Prompt do Sistema",
      systemPromptHelp: "Este é o prompt do sistema que guia a IA nos passos deste fluxo"
    },
    parameters: {
      title: "Parâmetros do fluxo",
      saveButton: "Salvar Parâmetros",
      saved: "Parâmetros salvos com sucesso",
      savedSuccess: "Parâmetros salvos com sucesso",
      missingRequired: "Campos obrigatórios não preenchidos",
      missingFields: "Campos obrigatórios ausentes",
      saveError: "Erro ao salvar parâmetros",
      missingRequiredField: "Campo obrigatório não preenchido: {{field}}",
      noParametersTitle: "Sem parâmetros definidos",
      noParametersDescription: "Este fluxo não possui parâmetros configuráveis definidos.",
      enabled: "Habilitado",
      disabled: "Desabilitado",
      required: "Obrigatório",
      types: {
        string: "Texto",
        number: "Número",
        select: "Seleção",
        boolean: "Sim/Não",
        json: "JSON"
      }
    },
    versions: {
      title: "Histórico de Versões",
      subtitle: "Histórico completo de todas as versões publicadas deste fluxo",
      noVersions: 'Nenhuma versão encontrada',
      versionNumber: 'Versão {{number}}',
      createdAt: 'Criada {{time}}',
      name: 'Nome',
      status: 'Status',
      description: 'Descrição',
      webhookPath: "Caminho do Webhook",
      webhookEndpoint: "Endpoint do Webhook",
      pathCopied: "Caminho copiado para a área de transferência",
      triggers: "Triggers Vinculados",
      restore: {
        button: 'Restaurar',
        confirmTitle: 'Restaurar Versão',
        confirmDescription: 'Isso irá restaurar esta versão como a versão atual do fluxo. A versão atual será arquivada. Deseja continuar?',
        confirm: 'Sim, restaurar',
        cancel: 'Cancelar',
        success: 'Versão restaurada com sucesso!',
        error: 'Erro ao restaurar versão'
      },
      statusLabels: {
        active: 'Ativo',
        inactive: 'Inativo',
        error: 'Erro',
        current: 'Atual',
        archived: 'Arquivada',
        published: 'Publicada',
        draft: 'Rascunho',
        deprecated: 'Descontinuada'
      }
    },
    versionHistory: {
      list_title: 'Histórico de Versões',
      list_subtitle: 'Histórico completo de todas as versões publicadas deste fluxo',
      empty: 'Nenhuma versão publicada',
      current: 'Versão atual',
      published: 'Publicado em',
      by: 'por',
      description: 'Descrição',
      actions: 'Ações'
    },
  },
  workflow: {
    title: "Workflow",
    description: "Configure o fluxo deste workflow",
    save: "Salvar",
    saving: "Salvando...",
    input: "Entrada",
    noInputTitle: "Sem entrada ainda!",
    noInputDesc: "Execute o node anterior para ver os dados de entrada aqui",
    noOutputTitle: "Sem saída ainda!",
    noOutputDesc: "Execute este node para ver os dados de saída aqui",
    executing: "Executando...",
    test: {
      title: 'Testar',
      button: 'Testar',
      description: 'Testar este node com a configuração atual',
      testing: 'Testando...',
      noTrigger: "É necessário configurar um gatilho (trigger) para o workflow antes de testá-lo",
      noTriggerTitle: "Gatilho não encontrado",
      error: "Erro ao testar workflow",
      errorTitle: "Erro no teste",
      pause: "Pausar execução"
    },
    testSuccessTitle: "Sucesso",
    testSuccess: "Workflow executado com sucesso",
    testErrorTitle: "Erro",
    testError: "Erro ao executar o workflow",
    nodeError: "Erro ao executar o node",
    nodeErrorGeneric: "Ocorreu um erro ao executar este node",
    noFields: "Este workflow não tem campos para configurar",
    noOutput: "Execute o teste para ver a saída aqui",
    tested: "Teste Concluído",
    testedSuccess: "Fluxo de trabalho testado com sucesso!",
    noWorkflow: "Nenhum workflow encontrado",
    noWorkflowDescription: "Este workflow ainda não tem um fluxo configurado.",
    unnamedNode: "Nó",
    loading: "Carregando workflow...",
    error: "Erro ao carregar o fluxo do workflow",
    new: "Novo Fluxo",
    create: "Criar",
    created: "Fluxo criado com sucesso",
    createError: "Erro ao criar fluxo",
    updated: "Fluxo atualizado com sucesso",
    updateError: "Erro ao atualizar fluxo",
    deleted: "Fluxo excluído com sucesso",
    deleteError: "Erro ao excluir fluxo",
    deleteConfirm: "Tem certeza que deseja excluir este fluxo?",
    nameRequired: "Nome é obrigatório",
    namePlaceholder: "Digite o nome do fluxo",
    select: "Selecionar Fluxo",
    selectPlaceholder: "Selecione um fluxo",
    components: "Componentes",
    nodeConfigSaved: "Configurações do node salvas com sucesso",
    nodeDeleted: "Node excluído com sucesso",
    node: {
      config: {
        title: "Configuração do Nó",
        description: "Configure os parâmetros do node",
        save: "Salvar",
        saving: "Salvando...",
        noFields: "Este node não possui campos para configurar",
        output: "Saída",
        noOutput: "Execute o teste para ver a saída",
        test: "Testar Node",
        testing: "Testando node...",
        testError: "Erro ao executar o node",
        testErrorTitle: "Erro no teste",
        testSuccess: "Node executado com sucesso",
        testSuccessTitle: "Sucesso"
      },
      error: {
        code: "Código do erro",
        type: "Tipo do erro",
        details: "Detalhes"
      },
      menu: {
        configure: "Configurar",
        delete: "Excluir"
      },
      title: {
        updated: "Título do node atualizado com sucesso",
        updateError: "Erro ao atualizar título do node"
      }
    },
    nodeConfig: {
      saveSuccess: "Configurações salvas",
      configurationUpdated: "As configurações do nó foram atualizadas com sucesso",
      saveError: "Erro ao salvar",
      saved: 'Configuração do node salva com sucesso',
      test: {
        success: "Teste realizado com sucesso",
        outputSaved: "Saída do teste foi salva"
      },
      array: {
        noItemFields: 'Esta lista não declara os campos dos itens, então as entradas não podem ser editadas aqui.'
      },
      mapping: {
        addItem: 'Adicionar Item',
        removeItem: "Remover",
        item: "Item",
        sourceField: "Campo de Origem",
        targetParameter: "Parâmetro de Destino",
        valueType: "Tipo do Valor",
        transformation: "Transformação",
        defaultValue: "Valor Padrão",
        types: {
          string: "Texto",
          number: "Número",
          boolean: "Booleano",
          object: "Objeto",
          array: "Lista"
        },
        transformations: {
          none: "Nenhuma",
          trim: "Remover Espaços",
          lowercase: "Minúsculas",
          uppercase: "Maiúsculas",
          capitalize: "Capitalizar"
        }
      },
      operators: {
        placeholder: 'Selecione o operador',
        starts_with: 'começa com',
        ends_with: 'termina com',
        contains: 'contém',
        equals: 'é igual a',
        not_equals: 'não é igual a',
        greater_than: 'é maior que',
        less_than: 'é menor que',
        greater_equals: 'é maior ou igual a',
        less_equals: 'é menor ou igual a',
        exists: 'existe',
        not_exists: 'não existe',
        empty: 'está vazio',
        not_empty: 'não está vazio',
        and: 'E',
        or: 'OU'
      }
    },
    categories: {
      API: "APIs",
      Databases: "Bancos de Dados",
      Files: "Arquivos",
      Embeddings: "Embeddings",
      Triggers: "Gatilhos",
      Transformers: "Transformadores",
      Chats: "Chats",
      "Knowledge Base": "Brain",
      Logic: "Lógica",
      other: "Outros",
      Service: "Serviços"
    },
    nodeTypes: {
      input: "Entrada de Dados",
      output: "Saída de Dados",
      process: "Processamento",
      condition: "Condição",
      loop: "Repetição"
    },
    nodes: {
      API: {
        title: "APIs",
        description: "Componentes para integração com APIs externas"
      },
      Databases: {
        title: "Bancos de Dados",
        description: "Componentes para integração com bancos de dados"
      },
      Files: {
        title: "Arquivos",
        description: "Componentes para manipulação de arquivos"
      },
      Embeddings: {
        title: "Embeddings",
        description: "Componentes para processamento de embeddings"
      },
      Triggers: {
        title: "Gatilhos",
        description: "Componentes para automação de fluxos"
      },
      other: {
        title: "Outros",
        description: "Outros componentes"
      }
    },
    triggers: {
      schedule: "Agendamento",
      webhook: "Webhook",
      manual: "Manual"
    },
    status: {
      draft: "Rascunho",
      active: "Ativo",
      inactive: "Inativo",
      error: "Erro"
    },
    executions: {
      title: "Execuções",
      description: "Histórico de execuções do workflow",
      columns: {
        id: {
          label: 'ID'
        },
        status: {
          label: 'Status'
        },
        agentVersion: {
          label: 'Versão do Workflow'
        },
        version: {
          label: 'Versão'
        },
        startedAt: {
          label: 'Iniciado em'
        },
        completedAt: {
          label: 'Finalizado em'
        }
      },
      status: {
        pending: 'Pendente',
        running: 'Em Execução',
        completed: 'Concluído',
        error: 'Erro',
        canceled: 'Cancelado'
      },
      noExecutions: "Nenhuma execução encontrada",
      execute: "Executar",
      executing: "Executando...",
      executeSuccess: "Workflow executado com sucesso",
      executeSuccessTitle: "Sucesso",
      executeError: "Erro ao executar workflow",
      executeErrorTitle: "Erro",
      actions: {
        viewDetails: "Ver detalhes"
      },
      details: {
        title: "Detalhes da Execução",
        subtitle: "Lista de logs dos nós desta execução",
        nodeTitle: "Título",
        nodeType: "Tipo do Nó",
        startedAt: "Iniciado em",
        completedAt: "Finalizado em",
        status: "Status",
        details: "Detalhes",
        input: "Entrada",
        processingLog: "Processamento",
        noProcessingLog: "Nenhum log de processamento capturado para esta execução.",
        downloadReport: "Baixar Log",
        output: "Saída",
        error: "Erro",
        noLogs: "Nenhum log encontrado para esta execução."
      }
    },
    webhook: {
      waiting_title: "Aguardando Webhook",
      waiting_message: "Aguardando resposta do webhook...",
      webhook_url: "URL do Webhook",
      cancel_button: "Cancelar",
      timeout: "Tempo limite excedido",
      timeout_description: "O webhook não respondeu no tempo esperado",
      waiting: "Aguardando resposta do webhook",
      waiting_description: "Aguarde enquanto o webhook é processado",
      success: "Webhook processado com sucesso",
      success_description: "O webhook foi processado com sucesso",
      error: "Erro ao processar o webhook",
      error_description: "Ocorreu um erro ao processar o webhook",
      cancel: "Cancelar",
      cancel_description: "Cancelar o processamento do webhook"
    }
  },
  executions: {
    status: "Status",
    startedAt: "Iniciado em",
    completedAt: "Finalizado em",
    agentVersion: "Versão do fluxo",
    noExecutions: "Nenhuma execução encontrada",
    subtitle: "Histórico de execuções do fluxo",
    actions: {
      viewDetails: "Ver detalhes"
    },
    status_types: {
      pending: "Pendente",
      running: "Em execução",
      completed: "Concluído",
      error: "Erro",
      failed: "Falhou",
      canceled: "Cancelado",
      started: "Iniciado",
      waiting: "Aguardando o agente",
      resuming: "Retomando"
    }
  },
  integrations: {
    title: "Ferramentas",
    description: "Gerencie as ferramentas do fluxo",
    selectTitle: "Selecionar ferramenta",
    searchPlaceholder: "Buscar ferramentas...",
    selectDescription: "Escolha uma ferramenta para adicionar ao seu fluxo",
    lastUpdated: "Última Atualização",
    neverUpdated: "Nunca Atualizada",
    integrationUrl: "URL da ferramenta",
    noIntegrationsAvailable: "Nenhuma ferramenta disponível para adicionar",
    noSearchResults: "Nenhuma ferramenta encontrada para sua busca",
    noDescription: "Sem descrição disponível",
    added: "✓",
    addedSuccessfully: "Ferramenta adicionada com sucesso",
    removedSuccessfully: "Ferramenta removida com sucesso",
    status: {
      active: "Ativo",
      inactive: "Inativo",
      pending: "Pendente",
      error: "Erro"
    }
  },
  list: {
    title: "Seus fluxos",
    description: "Gerencie os fluxos do workspace",
    empty: "Você ainda não tem nenhum fluxo"
  },
  titleUpdated: 'Título atualizado com sucesso',
  errorUpdatingTitle: 'Erro ao atualizar o título',
  // Workflow ainda não publicado: nada dispara
  draft: {
    badge: "Rascunho",
    footer: "Rascunho · não publicado",
  },
  // Busca e filtros da tela Flows
  filter: {
    searchPlaceholder: "Buscar por nome ou descrição",
    clearSearch: "Limpar busca",
    all: "Todos",
    installed: "Instalados",
    draft: "Rascunhos",
    available: "Disponíveis",
    trigger: "Gatilho",
    clear: "Limpar filtros",
    noResults: "Nenhum fluxo com esses filtros.",
  },
  // Gatilho no card do workflow
  trigger: {
    none: "Sem gatilho ativo",
    types: {
      schedule: "Horário",
      webhook: "Webhook",
      manual: "Manual",
      email: "E-mail",
      storage: "Arquivo",
      other: "Gatilho",
    },
    schedule: {
      everyMinute: "a cada minuto",
      everyNMinutes_one: "a cada {{count}} minuto",
      everyNMinutes_other: "a cada {{count}} minutos",
      hourly: "de hora em hora, aos {{minute}} min",
      everyNHours_one: "a cada {{count}} hora",
      everyNHours_other: "a cada {{count}} horas",
      daily: "todo dia às {{time}}",
      weekdays: "dias úteis às {{time}}",
      weekly: "{{days}} às {{time}}",
      monthly: "todo dia {{day}} às {{time}}",
      custom: "cron {{cron}}",
    },
    timezone: "Fuso: {{timezone}}",
  },
} as const;

export default agents;
